import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const section = document.querySelector(".concept");
const blocks = gsap.utils.toArray(".concept__block");

if (section && blocks.length > 1) {
  const mm = gsap.matchMedia();

  mm.add("(min-width: 768px)", () => {

    // ==========================================================
    // TOUT TON CODE ACTUEL À PARTIR D'ICI
    // ==========================================================

    const INITIAL_PAUSE_VH = 0.5;
    const PAUSE_VH = 0.5;
    const TRANSITION_VH = 0.5;
    const TRANSITION_DURATION = 1;

    blocks.forEach((block, index) => {
      const image = block.querySelector("img");
      const content = block.querySelector(".concept__content");

      gsap.set(block, {
        autoAlpha: index === 0 ? 1 : 0,
      });

      if (image) {
        gsap.set(image, {
          opacity: index === 0 ? 1 : 0,
          y: index === 0 ? 0 : 50,
        });
      }

      if (content) {
        gsap.set(content, {
          opacity: index === 0 ? 1 : 0,
          y: index === 0 ? 0 : -50,
        });
      }
    });

    const tl = gsap.timeline({
      paused: true,
    });

    tl.to({}, {
      duration: INITIAL_PAUSE_VH,
    });

    blocks.forEach((current, index) => {
      const next = blocks[index + 1];

      if (!next) return;

      const currentImage = current.querySelector("img");
      const currentContent = current.querySelector(".concept__content");

      const nextImage = next.querySelector("img");
      const nextContent = next.querySelector(".concept__content");

      const transitionStart = tl.duration();

      if (currentImage) {
        tl.to(
          currentImage,
          {
            opacity: 0,
            y: -50,
            duration: TRANSITION_DURATION,
            ease: "power2.inOut",
          },
          transitionStart
        );
      }

      if (currentContent) {
        tl.to(
          currentContent,
          {
            opacity: 0,
            y: 50,
            duration: TRANSITION_DURATION,
            ease: "power2.inOut",
          },
          transitionStart
        );
      }

      const switchTime =
        transitionStart + TRANSITION_DURATION;

      tl.set(
        current,
        {
          autoAlpha: 0,
        },
        switchTime
      );

      tl.set(
        next,
        {
          autoAlpha: 1,
        },
        switchTime
      );

      if (nextImage) {
        tl.fromTo(
          nextImage,
          {
            opacity: 0,
            y: 50,
          },
          {
            opacity: 1,
            y: 0,
            duration: TRANSITION_DURATION,
            ease: "power2.out",
          },
          switchTime
        );
      }

      if (nextContent) {
        tl.fromTo(
          nextContent,
          {
            opacity: 0,
            y: -50,
          },
          {
            opacity: 1,
            y: 0,
            duration: TRANSITION_DURATION,
            ease: "power2.out",
          },
          switchTime
        );
      }

      tl.to({}, {
        duration: PAUSE_VH,
      });
    });

    const getTotalScroll = () => {
      const initialPause = INITIAL_PAUSE_VH;

      const transitions =
        (blocks.length - 1) * TRANSITION_VH;

      const pauses =
        (blocks.length - 1) * PAUSE_VH;

      return initialPause + transitions + pauses;
    };

    const trigger = ScrollTrigger.create({
      trigger: section,

      start: "top top",

      end: () => {
        return `+=${getTotalScroll() * window.innerHeight}`;
      },

      pin: true,
      scrub: true,
      animation: tl,

      invalidateOnRefresh: true,
    });

    // Important si resize desktop <-> mobile
    return () => {
      trigger.kill();
      tl.kill();

      gsap.set(blocks, {
        clearProps: "all",
      });

      blocks.forEach((block) => {
        const image = block.querySelector("img");
        const content = block.querySelector(".concept__content");

        if (image) {
          gsap.set(image, {
            clearProps: "all",
          });
        }

        if (content) {
          gsap.set(content, {
            clearProps: "all",
          });
        }
      });
    };
  });
}